// extracted by mini-css-extract-plugin
module.exports = {"container":"_283yddk3","text":"_2Pg7UueB"};